document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.nav');
  const body = document.body;
  let isMenuOpen = false;

  function initMobileMenu() {
    if (!mobileMenuBtn || !nav) return;

    mobileMenuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      toggleMobileMenu();
    });
  }

  function toggleMobileMenu() {
    if (isMenuOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  }

  function openMobileMenu() {
    mobileMenuBtn.classList.add('active');
    nav.classList.add('active');
    body.classList.add('menu-open');
    isMenuOpen = true;
  }

  function closeMobileMenu() {
    mobileMenuBtn.classList.remove('active');
    nav.classList.remove('active');
    body.classList.remove('menu-open');
    isMenuOpen = false;
    closeAllDropdowns();
  }

  function closeAllDropdowns() {
    const openDropdowns = document.querySelectorAll('.header__dropdown.open');

    openDropdowns.forEach(dropdown => {
      dropdown.classList.remove('open');
      // Сбрасываем стрелку при закрытии всех дропдаунов
      const arrow = dropdown.closest('.nav__item')?.querySelector('.nav__arrow');
      if (arrow) {
        arrow.style.transform = 'rotate(0deg)';
      }
    });
  }

  function initMobileDropdown() {
    const dropdownTriggers = document.querySelectorAll('.nav__item:has(.header__dropdown) .nav__link');

    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        if (window.innerWidth <= 1100) {
          e.preventDefault();
          e.stopPropagation();

          const navItem = this.closest('.nav__item');
          const dropdown = navItem.querySelector('.header__dropdown');
          const arrow = navItem.querySelector('.nav__arrow');

          if (!dropdown) return;

          const allDropdowns = document.querySelectorAll('.header__dropdown.open');

          // Закрываем все другие дропдауны и сбрасываем их стрелки
          allDropdowns.forEach(d => {
            if (d !== dropdown) {
              d.classList.remove('open');
              const otherArrow = d.closest('.nav__item')?.querySelector('.nav__arrow');
              if (otherArrow) {
                otherArrow.style.transform = 'rotate(0deg)';
              }
            }
          });

          const isOpen = dropdown.classList.contains('open');

          if (isOpen) {
            // Закрываем дропдаун и возвращаем стрелку
            dropdown.classList.remove('open');
            if (arrow) {
              arrow.style.transform = 'rotate(0deg)';
            }
          } else {
            // Открываем дропдаун и поворачиваем стрелку
            dropdown.classList.add('open');
            if (arrow) {
              arrow.style.transform = 'rotate(180deg)';
            }
          }
        }
      });
    });
  }

  function initDesktopDropdown() {
    if (window.innerWidth > 1100) {
      const dropdownItems = document.querySelectorAll('.nav__item:has(.header__dropdown)');

      dropdownItems.forEach(item => {
        const dropdown = item.querySelector('.header__dropdown');
        const arrow = item.querySelector('.nav__arrow');

        item.addEventListener('mouseenter', function() {
          if (dropdown) {
            dropdown.style.opacity = '1';
            dropdown.style.visibility = 'visible';
            dropdown.style.transform = 'translateX(-50%) translateY(0)';
          }
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        });

        item.addEventListener('mouseleave', function() {
          if (dropdown) {
            dropdown.style.opacity = '0';
            dropdown.style.visibility = 'hidden';
            dropdown.style.transform = 'translateX(-50%) translateY(15px)';
          }
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        });
      });
    }
  }

  function initMenuLinks() {
    document.querySelectorAll('.nav-list > .nav__item > .nav__link[href^="#"]').forEach(link => {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 1100 && isMenuOpen) {
          e.preventDefault();
          const href = this.getAttribute('href');
          if (href && href !== '#') {
            closeMobileMenu();
            setTimeout(() => {
              const target = document.querySelector(href);
              if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }
        }
      });
    });

    document.querySelectorAll('.header__dropdown .nav__link[href^="#"]').forEach(link => {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 1100 && isMenuOpen) {
          e.preventDefault();
          closeMobileMenu();
          const href = this.getAttribute('href');
          if (href && href !== '#') {
            setTimeout(() => {
              const target = document.querySelector(href);
              if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
              }
            }, 300);
          }
        }
      });
    });

    const mobilePhone = document.querySelector('.mobile-phone');
    if (mobilePhone) {
      mobilePhone.addEventListener('click', function() {
        if (window.innerWidth <= 1100 && isMenuOpen) {
          closeMobileMenu();
        }
      });
    }

    const mobileBtn = document.querySelector('.mobile-btn');
    if (mobileBtn) {
      mobileBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (window.innerWidth <= 1100 && isMenuOpen) {
          closeMobileMenu();
        }
      });
    }
  }

  function initResizeHandler() {
    window.addEventListener('resize', function() {
      if (window.innerWidth > 1100 && isMenuOpen) {
        closeMobileMenu();
      }

      if (window.innerWidth <= 1100) {
        // Сбрасываем inline-стили для дропдаунов и стрелок
        document.querySelectorAll('.header__dropdown').forEach(dropdown => {
          dropdown.removeAttribute('style');
        });
        document.querySelectorAll('.nav__arrow').forEach(arrow => {
          arrow.style.transform = 'rotate(0deg)';
        });
      } else {
        // На десктопе сбрасываем классы открытия
        document.querySelectorAll('.header__dropdown.open').forEach(dropdown => {
          dropdown.classList.remove('open');
        });
        initDesktopDropdown();
      }
    });
  }

  function initClickOutside() {
    document.addEventListener('click', function(e) {
      if (isMenuOpen &&
          window.innerWidth <= 1100 &&
          !e.target.closest('.nav') &&
          !e.target.closest('.mobile-menu-btn')) {
        closeMobileMenu();
      }

      if (window.innerWidth <= 1100) {
        const isDropdownTrigger = e.target.closest('.nav__item:has(.header__dropdown)');
        const isInDropdown = e.target.closest('.header__dropdown');

        if (!isDropdownTrigger && !isInDropdown) {
          closeAllDropdowns();
        }
      }
    });
  }

  function initEscapeHandler() {
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        if (isMenuOpen) {
          closeMobileMenu();
        } else if (window.innerWidth <= 1100) {
          closeAllDropdowns();
        }
      }
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');

        if (href === '#' || href === '' || href.startsWith('tel:')) return;

        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();

          if (window.innerWidth <= 1100 && isMenuOpen) {
            closeMobileMenu();
            setTimeout(() => {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
          } else {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });
  }

  function init() {
    initMobileMenu();
    initMobileDropdown();
    initDesktopDropdown();
    initMenuLinks();
    initSmoothScroll();
    initResizeHandler();
    initClickOutside();
    initEscapeHandler();

    if (window.innerWidth > 1100) {
      initDesktopDropdown();
    }
  }

  init();
});
